/* eslint-disable react/jsx-props-no-spreading */
import { useMemo } from "react";
import { Provider } from "react-redux";
import MassSendMailerCampaign from "./MassSendMailerCampaign";

const MassSendMailerCampaignApp = (props) => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <MassSendMailerCampaign {...props} />
    </Provider>
  );
};

export default MassSendMailerCampaignApp;
